import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { TemplateServiceService } from './service/template-service.service'
import { SidebarService } from "src/app/core/services/sidebar.service";
import { Subscription } from 'rxjs';




@Component({
  selector: 'app-template-module',
  templateUrl: './template-module.component.html',
  styleUrls: ['./template-module.component.css']
})


export class TemplateModuleComponent implements OnInit {
  service_id: any;
  filter: any;
  count: any;
  sidebarCollapsed: boolean = false;
 
  private subscription: Subscription;

   


  constructor(private router: Router, private route: ActivatedRoute, private templateservice: TemplateServiceService,private sidebarService: SidebarService) {
    this.subscription = this.templateservice.currentCount.subscribe(count => {
      this.count = count;
      this.route.queryParams.subscribe(params => {
        this.filter = params['filter'];
        this.templateservice.updateLinkText(this.filter, this.count)

      });

    });
  }

  ngOnInit(): void {
     this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    this.route.queryParams.subscribe(params => {
      this.service_id = params['service_id'];
      this.filter = params['filter'];
      // this.count=params['count']
    });


  }

  logTemplateName(filter: any) {
    this.router.navigate(['/template/view_template'], {
      queryParams: {
        service_id: this.service_id,
        filter: filter
      }
    }).then(() => {
      // Reload the page after navigation
      window.location.reload();
    });
  }

  navigate() {
    const url = `/template/save_template?service_id=${this.service_id}&action=new&filter=addNew`;
    window.location.href = url;
  }

}

